import React from 'react';

import { Icon } from '../Icon/Icon';
import type { IconName } from '../Icon/icon.types';

import type { RawButtonProps } from './RawButton';
import { RawButton } from './RawButton';

export type ButtonProps = {
  fluid?: RawButtonProps['fluid'];
  children?: RawButtonProps['children'];
  className?: RawButtonProps['className'];
  alignContent?: RawButtonProps['alignContent'];
  disabled?: RawButtonProps['disabled'];
  icon?: IconName;
  iconPosition?: RawButtonProps['iconPosition'];
  id?: RawButtonProps['id'];
  inverse?: RawButtonProps['inverse'];
  name?: RawButtonProps['name'];
  onClick?: RawButtonProps['onClick'];
  /* @see RawButtonProps.onMouseEnter - a `Tooltip` anchor is made interactive through these. */
  onDoubleClick?: RawButtonProps['onDoubleClick'];
  onBlur?: RawButtonProps['onBlur'];
  onFocus?: RawButtonProps['onFocus'];
  onMouseEnter?: RawButtonProps['onMouseEnter'];
  onMouseLeave?: RawButtonProps['onMouseLeave'];
  onKeyDown?: RawButtonProps['onKeyDown'];
  onPointerDown?: RawButtonProps['onPointerDown'];
  pattern?: RawButtonProps['pattern'];
  title?: RawButtonProps['title'];
  /** @see RawButtonProps.download */
  download?: RawButtonProps['download'];
  to?: RawButtonProps['to'];
  toTab?: RawButtonProps['toTab'];
  type?: RawButtonProps['type'];
  variation?: RawButtonProps['variation'];
};

export const Button = ({
  fluid,
  children,
  className,
  alignContent,
  disabled,
  icon,
  iconPosition,
  id,
  inverse,
  name,
  onClick,
  onDoubleClick,
  onBlur,
  onFocus,
  onMouseEnter,
  onMouseLeave,
  onKeyDown,
  onPointerDown,
  pattern,
  title,
  download,
  to,
  toTab,
  type,
  variation,
}: ButtonProps) => {
  const ButtonIcon = icon ? <Icon name={icon} /> : null;
  return (
    <RawButton
      fluid={fluid}
      className={className}
      alignContent={alignContent}
      disabled={disabled}
      Icon={ButtonIcon}
      iconPosition={iconPosition}
      id={id}
      inverse={inverse}
      name={name}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onBlur={onBlur}
      onFocus={onFocus}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onKeyDown={onKeyDown}
      onPointerDown={onPointerDown}
      pattern={pattern}
      title={title}
      download={download}
      to={to}
      toTab={toTab}
      type={type}
      variation={variation}
    >
      {children}
    </RawButton>
  );
};
